import get from 'lodash/get'

export interface NurtureValue {
  startDate?: string
  endDate?: string
}

export const getNurture = (channelData): NurtureValue | false => {

  const features = get(channelData, 'features')
  if (!features || !Array.isArray(features)) {

    return false

  }

  const nurtureFeature = features.find(({ name, enabled, value }) => name === 'nurture' && enabled === true && !!value)

  if (!nurtureFeature) {

    return false

  }

  try {

    const parsedValue = JSON.parse(nurtureFeature.value)

    return {
      startDate: parsedValue.startDate,
      endDate: parsedValue.endDate
    }

  } catch (e) {

    return false

  }

}

